import Box from '@zenbusiness/zui/Box';
import Paper from '@zenbusiness/zui/Paper';
import { styled } from '@zenbusiness/zui/styles';

import { PaperStyle } from '#client/components/StepInfo/styles';

const ImageWrapperStyle = ({ theme }) => ({
  gridColumn: '2 / 4',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '3 / 5'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '1 / 6'
  }
});

const ContentWrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '7 / 13'
  }
});

export const PaperStyled = styled(Paper)(PaperStyle);
export const ImageWrapper = styled(Box)(ImageWrapperStyle);
export const ContentWrapper = styled(Box)(ContentWrapperStyle);
